/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watch_Video_ClipInputs */

const en_watch_video_clip = /** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Video Clip`)
};

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const es_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const fr_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const de_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const ja_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const zh_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const ar_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const id_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const it_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const ru_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const pt_watch_video_clip = en_watch_video_clip;

/** @type {(inputs: Watch_Video_ClipInputs) => LocalizedString} */
const ko_watch_video_clip = en_watch_video_clip;

/**
* | output |
* | --- |
* | "Watch Video Clip" |
*
* @param {Watch_Video_ClipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const watch_video_clip = /** @type {((inputs?: Watch_Video_ClipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watch_Video_ClipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_watch_video_clip(inputs)
	if (locale === "es") return es_watch_video_clip(inputs)
	if (locale === "fr") return fr_watch_video_clip(inputs)
	if (locale === "de") return de_watch_video_clip(inputs)
	if (locale === "ja") return ja_watch_video_clip(inputs)
	if (locale === "zh") return zh_watch_video_clip(inputs)
	if (locale === "ar") return ar_watch_video_clip(inputs)
	if (locale === "id") return id_watch_video_clip(inputs)
	if (locale === "it") return it_watch_video_clip(inputs)
	if (locale === "ru") return ru_watch_video_clip(inputs)
	if (locale === "pt") return pt_watch_video_clip(inputs)
	return ko_watch_video_clip(inputs)
});